import { cssClass } from "../../core/index.js";
export var cssPrefix = function cssPrefix(className) {
  return cssClass("slide_".concat(className));
};